import React from 'react';
import { List } from './List';

export default ({ t }) => <List />;
